import { FormItem, Select, SelectItem, ValidationError } from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { DestinationWindow } from "client/Api/Apps/common";

const destinationWindowOptions: readonly SelectItem<DestinationWindow>[] = [
	{ text: localize("_CurrentWindow"), value: DestinationWindow.CurrentWindow },
	{ text: localize("_NewWindow"), value: DestinationWindow.NewWindow }
];

export type AppDestinationWindowSelectFormItemProps = {
	attachable: IValueInputAttachable<DestinationWindow>;
};

export const AppDestinationWindowSelectFormItem = (props: AppDestinationWindowSelectFormItemProps): ReactElement => {
	const {
		attachable
	} = props;

	return (
		<FormItem
			label={localize("_Destination")}
		>
			<Select
				{...attachable.attachToSelect()}
				options={destinationWindowOptions}
				menuTitle={localize("_Destination")}
			/>
			<ValidationError {...attachable.attachToValidationError()} />
		</FormItem>
	);
};

AppDestinationWindowSelectFormItem.displayName = "AppDestinationWindowSelectFormItem";